<template>
  <zl-dialog class="zl-saas" title="询单终止" ref="dialog" width="960px">
    <div>
      <div class="m-b">
        <i class="el-icon-warning-outline"></i>
        终止的询单不可进行任何操作，且终止后的询单不可下订单。请确认是否终止？
      </div>
      <span v-if="isOpenApproval" class="saas-card-header-name">设置审批</span>
      <approve v-if="isOpenApproval" :flowType="flowType" ref="approve" :unionId="inquireId" />
    </div>
    <template slot="footer">
      <el-button size="small" plain type="primary" @click="cancel">
        取消
      </el-button>
      <el-button size="small" type="primary" :loading="btnLoading" @click="confirm">确定</el-button>
    </template>
  </zl-dialog>
</template>

<script>
import store from '@/store'
import approve from '@/components/business/approve.vue'
import commonMixins from '@/mixins/commonMixins'
export default {
  components: {
    approve
  },
  mixins: [commonMixins],
  data() {
    return {
      isOpenApproval: false,
      inquireId: '',
      btnLoading: false,
      flowType: 26
    }
  },
  computed: {
    // 是否小额采购
    isSmallScaleProcurement() {
      return store.state.isSmallScaleProcurement
    }
  },
  methods: {
    open(args) {
      this.inquireId = args.inquireId
      this.flowType = this.isSmallScaleProcurement ? 2688 : 26
      store
        .dispatch('approvalIsOpen', {
          flowType: this.flowType
        })
        .then((res) => {
          this.isOpenApproval = res
        })
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    },
    async confirm() {
      // const checkFileRes = await this.checkFileJinDu(this.$refs.approve.uploadIds)
      // console.log('----------------- checkFileRes', checkFileRes)
      // if (!checkFileRes) return
      this.btnLoading = true
      store
        .dispatch('stopInquire', {
          ...(this.isOpenApproval ? this.$refs.approve.getParmas() : {}),
          id: this.inquireId,
          submit: true
        })
        .then(() => {
          this.$zl.message.success('提交成功')
          this.$refs.dialog.close()
        }).finally(() => {
          this.btnLoading = false
        })
    }
  }
}
</script>

<style></style>
